import React from "react";
import { createAppKit } from "@reown/appkit/react";
import { WagmiProvider } from "wagmi";
import { http } from "viem";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { defineChain } from "@reown/appkit/networks";

const projectId = process.env.REACT_APP_REOWN_PROJECT_ID || "";

export const kubchainTestnet = defineChain({
  id: 25925,
  caipNetworkId: "eip155:25925",
  chainNamespace: "eip155",
  name: "Bitkub Chain Testnet",
  nativeCurrency: { name: "KUB", symbol: "tKUB", decimals: 18 },
  rpcUrls: { default: { http: ["https://rpc-testnet.bitkubchain.io"] } },
  blockExplorers: { default: { name: "Bitkub", url: "https://testnet.bkcscan.com" } },
});

export const kubchainMainnet = defineChain({
  id: 96,
  caipNetworkId: "eip155:96",
  chainNamespace: "eip155",
  name: "Bitkub Chain",
  nativeCurrency: { name: "KUB", symbol: "KUB", decimals: 18 },
  rpcUrls: { default: { http: ["https://rpc.bitkubchain.io"] } },
  blockExplorers: { default: { name: "Bitkub", url: "https://bkcscan.com" } },
});

const networks = [kubchainTestnet, kubchainMainnet];

export const APPKIT_NETWORKS = { 25925: kubchainTestnet, 96: kubchainMainnet };

const wantMainnet =
  (process.env.REACT_APP_KUBCHAIN_NETWORK || "").toLowerCase() === "mainnet" ||
  Number(process.env.REACT_APP_CHAIN_ID) === 96;
const defaultNetwork = wantMainnet ? kubchainMainnet : kubchainTestnet;

const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: false,
  transports: {
    [kubchainTestnet.id]: http("https://rpc-testnet.bitkubchain.io"),
    [kubchainMainnet.id]: http("https://rpc.bitkubchain.io"),
  },
});

export const wagmiConfig = wagmiAdapter.wagmiConfig;

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  defaultNetwork,
  projectId,
  allowUnsupportedChain: true,
  metadata: {
    name: "PAYD",
    description: "PAYD milestone escrow",
    url: typeof window !== "undefined" ? window.location.origin : "http://localhost:3000",
    icons: [],
  },
  features: { analytics: false, email: false, socials: false },
});

const queryClient = new QueryClient();

export const WalletProvider = ({ children }) => (
  <WagmiProvider config={wagmiAdapter.wagmiConfig}>
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  </WagmiProvider>
);
